export default function BadgeFooter(){
    return (
        <footer>
            <p>Badge React Component Project by Jun Dolor. Following were covered</p>
            <ul>
                <li>Created custom hooks</li>
                <li>Structured Compound components</li>
                <li>React context create and use</li>
                <li>Passing of components inner structure as Children props
</li>
            </ul>
            <p>Visit my LinkedIn profile at <a href="https://www.linkedin.com/in/jun-dolor/" target="_blank" rel="noreferrer">linkedin.com/in/jun-dolor/</a></p>
        </footer>
    )
}